import React, { useState, useEffect } from 'react';
// Components
import NuevoTelegram from './NuevoTelegram';
import EditarTelegram from './EditarTelegram';
import BorrarTelegram from './BorrarTelegram';
import TelegramTable from './Table';
// Material-UI
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
// Icons
import { CirclePlus, Pencil, Trash, CircleCheck, AlertCircle, X as XIcon } from 'tabler-icons-react';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
// Context
import { TelegramProvider, useTelegram } from './TelegramContext';
// Styles
import '../../styles/telegram.css';
import '../../styles/notifications.css';
import '../../App.css';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function TelegramView() {
    const { telegrams, selectionModel, snackbar, closeSnackbar } = useTelegram();
    const canEdit = selectionModel.length === 1;
    const canDelete = selectionModel.length > 0;
    const [nuevoOpen, setNuevoOpen] = useState(false);
    const [editarOpen, setEditarOpen] = useState(false);
    const [borrarOpen, setBorrarOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [rows, setRows] = useState([]);

    useEffect(() => { setRows(telegrams); }, [telegrams]);

    const requestSearch = (value) => {
        setSearchText(value);
        if (!value) { setRows(telegrams); return; }
        const re = new RegExp(escapeRegExp(value), 'i');
        setRows(telegrams.filter(row =>
            Object.keys(row).some(f => re.test(row[f]?.toString() ?? ''))
        ));
    };

    return (
        <div className="telegram-page">
            <div className="telegram-header">
                <h1 className="titulo">Telegram</h1>
                <p className="desc">
                    Configura qué grupos de Telegram recibirán las notificaciones de llamadas Andon según el área y el nivel de urgencia.
                </p>
            </div>

            <div className="telegram-body">
                {/* ── Tabla ── */}
                <div className="telegram-card">
                    <div className="telegram-card-toolbar">
                        <span className="telegram-selected-count">
                            {selectionModel.length > 0
                                ? `${selectionModel.length} seleccionado${selectionModel.length > 1 ? 's' : ''}`
                                : '0 seleccionados'}
                        </span>

                        <TextField
                            variant="outlined"
                            size="small"
                            value={searchText}
                            onChange={e => requestSearch(e.target.value)}
                            placeholder="Buscar..."
                            className="table-search-inline"
                            InputProps={{
                                startAdornment: <SearchIcon fontSize="small" />,
                                endAdornment: (
                                    <IconButton
                                        size="small"
                                        className={searchText ? 'table-search-clear-visible' : 'table-search-clear-hidden'}
                                        onClick={() => requestSearch('')}
                                    >
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                ),
                            }}
                        />

                        <div className="telegram-card-actions">
                            <Button variant="text" className="usuarios-toolbar-btn" onClick={() => setNuevoOpen(true)}>
                                <CirclePlus size={16} strokeWidth={2} /> Nuevo
                            </Button>
                            <Button variant="text" className="usuarios-toolbar-btn" disabled={!canEdit} onClick={() => setEditarOpen(true)}>
                                <Pencil size={16} strokeWidth={2} /> Editar
                            </Button>
                            <Button variant="text" className="usuarios-toolbar-btn usuarios-toolbar-btn--danger" disabled={!canDelete} onClick={() => setBorrarOpen(true)}>
                                <Trash size={16} strokeWidth={2} /> Borrar
                            </Button>
                        </div>
                    </div>
                    <div className="telegram-table-wrapper">
                        <TelegramTable rows={rows} />
                    </div>
                </div>

            </div>

            <NuevoTelegram open={nuevoOpen} onClose={() => setNuevoOpen(false)} />
            <EditarTelegram open={editarOpen} onClose={() => setEditarOpen(false)} />
            <BorrarTelegram open={borrarOpen} onClose={() => setBorrarOpen(false)} />

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={closeSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <div className={`app-notif app-notif--${snackbar.severity}`}>
                    {snackbar.severity === 'success'
                        ? <CircleCheck size={20} strokeWidth={2} className="app-notif__icon" />
                        : <AlertCircle size={20} strokeWidth={2} className="app-notif__icon" />
                    }
                    <span className="app-notif__msg">{snackbar.message}</span>
                    <button className="app-notif__close" onClick={closeSnackbar}>
                        <XIcon size={16} strokeWidth={2} />
                    </button>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>
        </div>
    );
}

const TelegramPage = () => (
    <TelegramProvider>
        <TelegramView />
    </TelegramProvider>
);

export default TelegramPage;
